import React from 'react';
import classnames from 'classnames';

import Image from 'components/Image';

import getModifier from './getModifier';
import { IQuality } from 'types/qualities';
import { ITooltipData } from 'components/ModalTooltip/types';

const MENACE = 'Menace';

interface Props extends IQuality {
  tooltipData: ITooltipData,
}

export default function SidebarQuality({
  category,
  image,
  effectiveLevel,
  level,
  name,
  progressAsPercentage,
  tooltipData,
}: Props) {
  const modifier = getModifier({ effectiveLevel, level });

  return (
    <li className="js-item item">
      <div className="js-icon icon js-tt icon--circular">
        <Image
          defaultCursor
          alt={name}
          icon={image}
          type="small-icon"
          tooltipData={tooltipData}
          tooltipPos="right"
        />
      </div>
      <div className="item__desc">
        <span className="js-item-name item__name">{name}</span>
        {' '}
        {' '}
        {' '}
        <span className="item__value">{level}</span>
        {modifier && <span className="item__adjust">{modifier}</span>}
        <div className={classnames('progress-bar', category === MENACE && 'progress-bar--menace')}>
          <span
            className={classnames(
              'progress-bar__stripe progress-bar__stripe--has-transition',
              category === MENACE && 'progress-bar__stripe--menace',
            )}
            style={{ width: `${Number(progressAsPercentage) || 0}%` }}
          />
        </div>
      </div>
    </li>
  );
}

/*
SidebarQuality.propTypes = {
  category: PropTypes.string.isRequired,
  effectiveLevel: PropTypes.number.isRequired,
  image: PropTypes.string.isRequired,
  level: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  progressAsPercentage: PropTypes.number.isRequired,
  tooltipData: PropTypes.shape({}).isRequired,
};

 */

